import React from "react";
import styles from "./CalendarLinkPopup.module.scss";
import Button from "../../components/Button/Button";
import { ReactComponent as CopyIcon } from "../../icons/copy.svg";
import OutsideClickHandler from "react-outside-click-handler";
import { useTranslation } from "react-i18next";

const CalendarLinkPopup = ({ onClose, link }) => {
  const { t } = useTranslation();

  const handleCopy = () => {
    navigator.clipboard.writeText(link);
  };

  return (
    <div className={styles.overlay}>
      <OutsideClickHandler onOutsideClick={onClose}>
        <div className={styles.popup}>
          <p style={{ marginBottom: "8px", fontSize: "14px" }}>
            <p style={{ marginBottom: "8px", fontSize: "14px" }}>
              {t("calendarLinkPopup.description.line1")} <br /><br />
              <b>{t("calendarLinkPopup.description.doNotShare")}</b> <br /><br />
              {t("calendarLinkPopup.description.line2")}
            </p>
          </p>
          <div className={styles.linkContainer}>
            <input value={link} readOnly className={styles.linkInput} />
            <button
              onClick={handleCopy}
              className={styles.copyButton}
              aria-label={t("calendarLinkPopup.copyAria")}
            >
              <CopyIcon />
            </button>
          </div>
          <div className={styles.buttonGroup}>
            <Button
              text={t("calendarLinkPopup.gotIt")}
              onClick={onClose}
              className={styles.confirmButton}
            />
          </div>
        </div>
      </OutsideClickHandler>
    </div>
  );
};

export default CalendarLinkPopup;
